<template>
  <v-layout row wrap>
    <v-flex xs6>
      <v-form class="px-2">
        <!-- Rule Collection Type -->
        <v-flex xs4>
          <v-select v-model="ruleCollectionInfo.type" item-text="title" item-value="value" :disabled="isEditMode"
            @change="updateAddRuleSetsFilters(); handleRuleCollectionTypeChange()"
            :label="messages.label.RULE_COLLECTION_TYPE" :items="ruleCollectionTypeList"></v-select>
        </v-flex>
        <!-- Rule Collection Title -->
        <v-flex xs10>
          <v-text-field v-model="ruleCollectionInfo.title" clearable v-validate="{ required: true, max:100, regex: /^[0-9a-zA-Z\s\/_-]*$/i }"
            :error-messages="errors.collect('title')" data-vv-name="title" :counter="100"
            :label="messages.label.RULE_TITLE" required></v-text-field>
        </v-flex>
        <!-- Rule Collection Description -->
        <v-flex xs10>
          <v-textarea v-model="ruleCollectionInfo.description" clearable v-validate="{max:500}"
            :error-messages="errors.collect('description')" data-vv-name="description" :counter="500"
            :label="messages.label.RULE_DESCRIPTION" required></v-textarea>
        </v-flex>
        <!-- Rule Collection Enabled -->
        <v-flex xs4>
          <span class="subheading">{{ messages.label.ENABLED }}</span>
          <v-switch v-model="ruleCollectionEnabled" color="primary" class="mt-0"
            :label="`${ruleCollectionEnabled.toString()}`"></v-switch>
        </v-flex>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapMutations } from "vuex"
import messages from "@/XVAT/messages.json"
import XVATRulesService from "@/XVAT/XVATRulesService"
import { SET_ADD_RULE_SETS_FILTERS, SET_RULECOLLECTION_RULESETS } from "@/store/constants/mutation-types"
import {
  RULE_TYPE_VALIDATION
} from "../constants"

export default {
  name: "RuleCollectionInfo",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      ruleCollectionTypeList: XVATRulesService.getRuleTypeList(),
      isEditMode: false,
      ruleCollectionInfo: {
        type: RULE_TYPE_VALIDATION,
        title: "",
        description: "",
        enabled: true
      },
      ruleCollectionEnabled: true, // NOTE: Using this outside of "ruleCollectionInfo" as binding is not working
      dictionary: this.getValidationDictionary()
    }
  },
  methods: {
    ...mapMutations("xvat", [
      SET_ADD_RULE_SETS_FILTERS,
      SET_RULECOLLECTION_RULESETS
    ]),

    /**
     * getValidationDictionary - Validation messages for vee-validate
     * @returns {object}
     */
    getValidationDictionary() {
      return {
        custom: {
          title: {
            required: () => "Title can't be empty",
            max: "Title may not be greater than 100 characters",
            regex: "Valid characters are : A-Z a-z 0-9 / _ -"
          },
          description: {
            max: "Description may not be greater than 500 characters"
          }
        }
      }
    },

    /**
     * resetData - Reset rule info data
     */
    resetData() {
      this.ruleCollectionInfo = {
        type: RULE_TYPE_VALIDATION,
        title: "",
        description: "",
        enabled: true
      }
      this.ruleCollectionEnabled = true
      this.isEditMode = false
    },

    /**
     * resetRuleCollectionInfo - Reset rule collection data and form
     */
    resetRuleCollectionInfo() {
      this.resetData()
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },

    /**
     * loadRuleCollectionInfo - update view with rule collection data
     * @param {object} ruleCollectionData
     */
    loadRuleCollectionInfo(ruleCollectionData) {
      this.resetRuleCollectionInfo()
      if (!this.$lodash.isUndefined(ruleCollectionData)) {
        this.isEditMode = true
        this.ruleCollectionInfo.type = ruleCollectionData.type
        this.ruleCollectionInfo.title = ruleCollectionData.title
        this.ruleCollectionInfo.description = decodeURI(ruleCollectionData.description)
        this.ruleCollectionInfo.enabled = !ruleCollectionData.disabled
        this.ruleCollectionEnabled = this.ruleCollectionInfo.enabled // UI Specific
        this.updateAddRuleSetsFilters()
      } else {
        this.isEditMode = false
      }
    },

    /**
     * validate - Validate
     */
    validate() {
      this.$validator.validateAll()
        .then((result) => {
          this.ruleCollectionInfo.enabled = this.ruleCollectionEnabled // Please see note at the definition of this property in "data"
          if (this.$lodash.isNull(this.ruleCollectionInfo.description)) {
            this.ruleCollectionInfo.description = ""
          }
          XVATRulesService.$emit("event:ruleCollectionInfoValidation", result, this.ruleCollectionInfo)
        })
    },

    /**
     * updateAddRuleSetsFilters - Update to ensure that 'Add Rulesets' fetches correct data
     */
    updateAddRuleSetsFilters() {
      let addRuleSetsFilters = {
        ruleCollectionType: this.ruleCollectionInfo.type
      }
      this.SET_ADD_RULE_SETS_FILTERS(addRuleSetsFilters)
      XVATRulesService.$emit("event:addRuleSetsFilterUpdated")
    },
    /**
    * handleRuleCollectionTypeChange - Update the RulesSetRulesList when user change the ruleType
    */
    handleRuleCollectionTypeChange() {
      let ruleCollectionRuleSetsList = []
      this.SET_RULECOLLECTION_RULESETS(ruleCollectionRuleSetsList)
      XVATRulesService.$emit("event:ruleCollectionTypeChanged", this.ruleCollectionInfo.type)
    }
  },
  mounted() {
    // Validator initialization
    this.$validator.localize("en", this.dictionary)
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    this.updateAddRuleSetsFilters()

    /**
     * Events
     */
    XVATRulesService.$on("event:ruleCollectionDataRetrieved", this.loadRuleCollectionInfo)
    XVATRulesService.$on("event:validateRuleCollectionInfo", this.validate)
  },
  beforeDestroy() {
    XVATRulesService.$off("event:validateRuleCollectionInfo", this.validate)
    XVATRulesService.$off("event:ruleCollectionDataRetrieved", this.loadRuleCollectionInfo)
  }
}
</script>
<style lang="sass">

</style>



// WEBPACK FOOTER //
// src/XVAT/RuleCollection/RuleCollectionInfo.vue